function serializeError(error: unknown): string {
  if (!error) return ''
  try {
    if (typeof (error as { toJSON?: () => unknown }).toJSON === 'function') {
      return JSON.stringify((error as { toJSON: () => unknown }).toJSON())
    }
    if (error instanceof Error) {
      return JSON.stringify({
        name: error.name,
        message: error.message,
        stack: error.stack,
      })
    }
    return JSON.stringify(error)
  } catch {
    return String((error as Error)?.message ?? error)
  }
}

export { serializeError }
